import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from "recharts";
import { AGING_COLORS, fmtInt } from "@/lib/format";
import { Hourglass } from "@phosphor-icons/react";

const DarkTooltip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  const p = payload[0].payload;
  return (
    <div className="rounded-sm border border-[#CAD1DB] bg-[#FFFFFF] px-3 py-2 text-xs">
      <div className="mb-1 font-mono text-[#64748B]">{label} days</div>
      <div className="font-mono text-[#0F172A]">{fmtInt(p.count)} lines</div>
    </div>
  );
};

export const AgingChart = ({ aging }) => {
  const data = aging || [];
  return (
    <div className="col-span-12 border border-[#E3E7EC] bg-[#FFFFFF] p-5 lg:col-span-8">
      <div className="mb-4 flex items-center gap-2">
        <Hourglass size={18} weight="duotone" className="text-amber-400" />
        <div>
          <h3 className="text-sm font-semibold text-[#0F172A]">Aging of Unprocessed Lines</h3>
          <p className="pf-label mt-0.5">Days open since order date</p>
        </div>
      </div>
      <div className="h-64" data-testid="aging-chart">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} margin={{ top: 5, right: 8, left: -8, bottom: 0 }}>
            <CartesianGrid stroke="#E3E7EC" vertical={false} />
            <XAxis dataKey="bucket" tick={{ fill: "#64748B", fontSize: 11, fontFamily: "IBM Plex Mono" }} axisLine={false} tickLine={false} />
            <YAxis tickFormatter={fmtInt} tick={{ fill: "#64748B", fontSize: 11, fontFamily: "IBM Plex Mono" }} axisLine={false} tickLine={false} width={44} />
            <Tooltip cursor={{ fill: "rgba(255,255,255,0.03)" }} content={<DarkTooltip />} />
            <Bar dataKey="count" radius={[2, 2, 0, 0]} maxBarSize={90}>
              {data.map((d) => (
                <Cell key={d.bucket} fill={AGING_COLORS[d.bucket] || "#64748B"} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};
